/* global app, grecaptcha */

export const withCaptchaToken = (formData, action) => new Promise((resolve) => {
    grecaptcha.ready(async () => {
      const token = await grecaptcha.execute(app.config.keys.recaptcha, {
        action
      })

      if (formData instanceof HTMLElement) {
        formData.insertAdjacentHTML('beforeend', `<input type="hidden" name="g-recaptcha-response" value="${token}" />`)
      } else {
        formData.append('g-recaptcha-response', token);
      }

      resolve(formData);
    });
  });

export const renderCaptchaScript = () => {
  const imported = document.createElement('script');
  imported.src = `https://www.google.com/recaptcha/api.js?render=${app.config.keys.recaptcha}`;
  document.head.appendChild(imported);
}

export default withCaptchaToken;
